import {
    Grid, Box, Typography, Select, MenuItem, InputLabel,
    FormControl, Paper, Card, CardContent, Divider
} from '@mui/material';
import ProjectMgmt from './ProjectMgmt';
import EmployeeTaskViewer from './EmployeeTaskViewer';
import useAuthStore from '../../../Zustand/Store/useAuthStore';
import usePermissionDataStore from '../../../Zustand/Store/usePermissionDataStore';
import TasksMgmt from './TasksMgmt';
import InProgessTasks from './InProgessTasks';



function ProjectExplorer() {

    const { logout, userData, setAccess, login, reporting_manager_employees, reporting_manager_interns } = useAuthStore();
    const { Permission } = usePermissionDataStore();


    console.log(
        "Permissionsssssssss",
        Permission.filter(i => i.startsWith("VIEW"))
      );

    const showFullDashboard = Permission && Permission.includes("VIEW_ALL_TASKS");
    const showSelfPortal =
        Permission &&
        (Permission.includes("VIEW_SELF_TASK") ||
            (Permission.includes("VIEW_TEAM_TASKS") &&
                (reporting_manager_employees?.length > 0 || reporting_manager_interns?.length > 0)));

    return (
        <Box sx={{ p: 3 }}>
            {showFullDashboard && (
                <>
                    <Typography variant="h4" fontWeight="bold" mb={4}>Project Management Dashboard</Typography>
                    <Grid container spacing={4} direction={'column'}>
                        <EmployeeTaskViewer heading={"Tasks"} />
                        <hr />
                        <InProgessTasks />
                        <hr />
                        <ProjectMgmt />
                    </Grid>
                </>
            )}
            {!showFullDashboard && showSelfPortal && (
                <>
                    <Typography variant="h4" fontWeight="bold" mb={4}>Your All Tasks</Typography>
                    <Grid container spacing={4} direction={'column'}>
                        {Permission.includes("VIEW_SELF_TASK") && <TasksMgmt />}
                        {Permission.includes("VIEW_TEAM_TASKS") &&
                            (reporting_manager_employees?.length > 0 || reporting_manager_interns?.length > 0) &&
                            <EmployeeTaskViewer heading={"Your Team Tasks"} />}
                    </Grid>
                </>
            )}
        </Box>
    );
}

export default ProjectExplorer;
